<template>
  <modal-template ref="modal" modal-size="sm" title="Upload de Arquivos" type-modal="upload_file_modal">
    <div class="modal-content__main">
      <d-form>

        <d-form-row>
          <d-col class="form-group">
            <label for="feName" class="m-0 p-0">Nome</label>
            <d-form-input type="text" v-model="model.name" id="feName" placeholder="Nome" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col class="form-group">
            <label for="feName" class="m-0 p-0">Arquivo</label>
            <input type="file" class="form-control upload" @change="choseFile($event)">
          </d-col>
        </d-form-row>

      </d-form>
    </div>
    <div slot="actions" class="modal-content__control">
      <d-button type="button" class="btn btn-sm btn-secondary mr-3" @click="cancel">Cancelar</d-button>
      <d-button type="button" class="btn btn-sm btn-primary" @click="save">Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import Events from '_utils/events';
import CustomerService from '_services/rest/modules/customer';
import { FILE, _SAVE_FILE_SUCCESS_, _SAVE_CUSTOMER_SUCCESS_ } from '../CustomerModel';

export default {
  name: 'upload-customer-file',
  components: {
    ModalTemplate,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      model: { ...FILE },
    };
  },
  computed: {
    tempFiles() {
      const { tempFiles } = this.$store.state.customer;
      if (tempFiles && tempFiles.length > 0) {
        return tempFiles;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'setTempFiles',
      'clearTempFiles',
    ]),
    cancel() {
      this.setToggle({ type: 'upload_file_modal', bool: false });
    },
    choseFile(event) {
      const [file] = event.target.files;
      this.model.file = file;
    },
    save() {
      this.model.id = this.customerId ? this.customerId : this.tempFiles.length + 1;
      if (!this.customerId) {
        this.saveFileToTempFiles(this.model);
      } else {
        this.saveFileToServer(this.model);
      }
    },
    saveFileToTempFiles(newFile) {
      this.setTempFiles([...this.tempFiles, newFile]);
      this.model = { ...FILE };
      this.cancel();
    },
    saveFileToServer(newFile) {
      CustomerService.uploadFile(newFile)
        .then(() => {
          this.model = { ...FILE };
          this.cancel();
          Events.$emit(_SAVE_FILE_SUCCESS_);
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    handleSaveCustomerSuccess(customer) {
      this.tempFiles.forEach(file => {
        const newFile = {
          id: customer.id,
          name: file.name,
          file: file.file,
        };
        CustomerService.uploadFile(newFile);
      });
      this.clearTempFiles();
      Events.$emit(_SAVE_FILE_SUCCESS_);
    },
  },
  mounted() {
    this.clearTempFiles();
    Events.$on(_SAVE_CUSTOMER_SUCCESS_, this.handleSaveCustomerSuccess);
  },
  beforeDestroy() {
    Events.$off(_SAVE_CUSTOMER_SUCCESS_, this.handleSaveCustomerSuccess);
  },
};
</script>
